export default __webpack_public_path__ + "static/media/seller-2.14dcb151.png";